import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';
import { getReportFields } from '@/api/operator/cgi/smb/report/meta';
import { Timeline } from '@/model/report';

// 查询业务单元
export const getBusinessUnitList = (data: Record<string, any>, options?: any) => {
  const url = getAgpApiUrl('eservice/material_lib', 'business_units');
  return smb_fetch(url, {
    method: 'GET',
    data,
    ...options || {},
  }, true, false);
};

export const getMdmList = (data: any = {}, options?: any) => {
  const url = getAgpApiUrl('eservice/material_lib', 'mdms');
  return smb_fetch(url, {
    method: 'GET',
    data,
    ...options || {},
  }, true, false);
};

export const getCreativeMdmList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material_lib', 'ids');
  return smb_fetch(url, {
    method: 'GET',
    ...data,
  }, true, false);
};

export const createLibId = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material_lib', 'ids');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const getTaccToken = (data: any) => {
  const url = getAgpApiUrl('eservice/material', 'get_token');
  return smb_fetch(url, {
    method: 'GET',
    data,
  }, false, false);
};

export const getImageByMd5 = (data: any) => {
  const { uid, image_signature } = data || {};
  const url = getAgpApiUrl('eservice/material', 'get_image_by_md5');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data: {
      image_signature,
      lib_id: uid,
    },
  }, false, false).then((res: any) => ({ error_message: res.data?.[0]?.image_id ? '图片已存在' : '' }));
};

export const createImage = (data: any) => {
  const url = getAgpApiUrl('eservice/material', 'push_image');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const batchCreateVideo = (data: any) => {
  const url = getAgpApiUrl('eservice/material', 'push_media');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const getImageList = (data: any = {}, isShowError = true) => {
  const url = getAgpApiUrl('eservice/material_lib', 'images');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCancel: true,
    ...data,
  }, isShowError, false);
};

export const getVideoList = (data: any = {}, isShowError = true) => {
  const url = getAgpApiUrl('eservice/material_lib', 'medias');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCancel: true,
    ...data,
  }, isShowError, false);
};

export const updateMaterial = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'update');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const deleteMaterial = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'batch_delete');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    loadingTip: '素材删除中，请稍后',
  }, true, false);
};

export const updateMateiralTag = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'label');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const updateMateiralOwner = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'update_owner');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const appendMateiralOwner = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'append_owner');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const getTagList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'get_label_list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCache: true,
    cacheMaxAge: 1000,
    ...data,
  }, true, false);
};

export const getTagLevel = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'get_label_level');
  return smb_fetch(url, {
    method: 'GET',
    data,
    isCache: true,
    cacheMaxAge: 1000,
  }, false, false);
};

export const createTags = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'create_label');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const updateTag = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'update_label');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const deleteTag = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'delete_label');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    loadingTip: '标签删除中，请稍后',
  }, true, false);
};

export const getReportColulmns = () => getReportFields({
  name: 'AgentResourceRpt',
  unified: 1,
  time_line: Timeline.report,
});

export const getEnumList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'get_enum_list');
  return smb_fetch(url, {
    method: 'GET',
    data,
    isCache: true,
    cacheMaxAge: 1000,
  }, false, false);
};

export const getAuditSecretList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'get_yidun_token');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const createAuditSecret = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'create_yidun_token');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '账号绑定中，请稍后',
    data,
  }, true, false);
};

export const refreshAuditSecret = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'refresh_yidun_token_status');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const getAuditSwitchList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'get_pre_audit_switch_list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    ...data,
  }, true, false);
};

export const getAuditDefaultSwitch = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'get_pre_audit_switch_template');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const updateAuditDefaultSwitch = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'update_pre_audit_switch_template');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '保存配置中，请稍后',
    data,
  }, true, false);
};

export const createAuditSwitch = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'create_pre_audit_switch');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const updateAuditSwitch = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'update_pre_audit_switch');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '更新开关状态中，请稍后',
    data,
  }, true, false);
};

export const getAuditImageList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material_lib', 'audit_images');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCancel: true,
    ...data,
  }, true, false);
};

export const getAuditVideoList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material_lib', 'audit_medias');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCancel: true,
    ...data,
  }, true, false);
};

export const updateMateiralAuditStatus = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/pre_audit', 'reviews');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '审核结果提交中，请稍后',
    data,
  }, true, false);
};

export const reSubmitAudit = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/pre_audit', 'resubmit');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '重新送审中，请稍后',
    data,
  }, true, false);
};

export const getAuditMdmList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'get_audit_switch_mdms');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, false, false);
};

export const getMaterialReportOwner = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'user_effectiveness_report');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCancel: true,
    ...data,
  }, true, false);
};

export const getAIGCExcitationList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/creative', 'get_creative_aigc_excitation_list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCancel: true,
    ...data,
  }, true, false);
};

export const getSyncMaterialList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material_lib', 'resource_in_sync');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, false, false);
};

export const getMachineAuditDetail = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/material', 'get_machine_audit_hit_info');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCancel: true,
    data,
  }, true, false);
};
